import { render, staticRenderFns } from "./PromoKhusus.vue?vue&type=template&id=55249c92"
import script from "./PromoKhusus.vue?vue&type=script&lang=js"
export * from "./PromoKhusus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports